import React from "react";
import { useTable, usePagination, useGlobalFilter } from "react-table";

// A great library for fuzzy filtering/sorting items

import makeData from "./makeData";

// Our table component
function Table({ columns, data }) {
  const props = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter, // useGlobalFilter!
    usePagination
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setGlobalFilter,
    state,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize, globalFilter },
  } = props;
  console.log(props);
  React.useEffect(() => {
    // props.dispatch({ type: actions.resetPage })
    console.log(globalFilter);
  }, [globalFilter]);

  return (
    <>
      {console.log(globalFilter)}
      <input
        type="text"
        value={globalFilter || ""}
        onChange={(e) => setGlobalFilter(e.target.value)}
      />
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr
              style={{
                backgroundColor: "#003600",
                color: "white",
                fontSize: "24px",
              }}
              {...headerGroup.getHeaderGroupProps()}
            >
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>
                  {column.render("Header")}
                  {/* Render the columns filter UI */}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr
                style={{
                  fontSize: "20px",
                }}
                {...row.getRowProps()}
              >
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="pagination">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {"<<"}
        </button>{" "}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {"<"}
        </button>{" "}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {">"}
        </button>{" "}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {">>"}
        </button>{" "}
        <span>
          Page{" "}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{" "}
        </span>
        <span>
          | Go to page:{" "}
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={(e) => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0;
              gotoPage(page);
            }}
            style={{ width: "100px" }}
          />
        </span>{" "}
        <select
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
          }}
        >
          {[10, 20, 30, 40, 50].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
      </div>

      <br />
      {/* <div>Showing the first 20 results of {rows.length} rows</div> */}
      <div>
        <pre>
          <code>{JSON.stringify(state.filters, null, 2)}</code>
        </pre>
      </div>
    </>
  );
}

export default function CpWorldWideTable() {
  const columns = React.useMemo(
    () => [
      {
        Header: " ",
        columns: [
          {
            Header: "ประเทศ",
            accessor: "country",
          },
          {
            Header: "กำลังการผลิต",
            accessor: "production",
          },
          {
            Header: "ปริมาณผลิต",
            accessor: "productionValue",
            filter: "equals",
          },
          {
            Header: "%utilize",
            accessor: "percentUtilize",
          },
          {
            Header: "ใช้เอง",
            accessor: "inUsed",
            filter: "includes",
          },
          {
            Header: "%",
            accessor: "percentInused",
          },
          {
            Header: "ลูกค้า",
            accessor: "customer",
          },
          {
            Header: "%",
            accessor: "percentCustomer",
          },
        ],
      },
    ],
    []
  );

  const dataSet = [
    {
      country: "ไทย",
      production: "7,150",
      productionValue: "5,755",
      percentUtilize: "80%",
      inUsed: "3,833",
      percentInused: "67%",
      customer: "1,922",
      percentCustomer: "33%",
    },
    {
      country: "เวียดนาม",
      production: "4,956",
      productionValue: "3,995",
      percentUtilize: "81%",
      inUsed: "2,733",
      percentInused: "68%",
      customer: "1,262",
      percentCustomer: "32%",
    },
    {
      country: "ตุรกี",
      production: "1,498",
      productionValue: "844",
      percentUtilize: "56%",
      inUsed: "94",
      percentInused: "11%",
      customer: "750",
      percentCustomer: "89%",
    },
    {
      country: "รัสเซีย",
      production: "1,416",
      productionValue: "1,202",
      percentUtilize: "85%",
      inUsed: "1,202",
      percentInused: "100%",
      customer: "",
      percentCustomer: "",
    },
    {
      country: "เมียนม่า",
      production: "936",
      productionValue: "750",
      percentUtilize: "80%",
      inUsed: "379",
      percentInused: "51%",
      customer: "371",
      percentCustomer: "49%",
    },
    {
      country: "แคนาดา",
      production: "855",
      productionValue: "744",
      percentUtilize: "87%",
      inUsed: "744",
      percentInused: "100%",
      customer: "",
      percentCustomer: "",
    },
    {
      country: "ไต้หวัน",
      production: "836",
      productionValue: "836",
      percentUtilize: "100%",
      inUsed: "319",
      percentInused: "38%",
      customer: "518",
      percentCustomer: "62%",
    },
    {
      country: "มาเลเซีย",
      production: "636",
      productionValue: "527",
      percentUtilize: "83%",
      inUsed: "222",
      percentInused: "42%",
      customer: "305",
      percentCustomer: "58%",
    },
    {
      country: "อินเดีย",
      production: "636",
      productionValue: "411",
      percentUtilize: "65%",
      inUsed: "133",
      percentInused: "32%",
      customer: "277",
      percentCustomer: "68%",
    },
    {
      country: "กัมพูชา",
      production: "630",
      productionValue: "643",
      percentUtilize: "102%",
      inUsed: "547",
      percentInused: "85%",
      customer: "96",
      percentCustomer: "15%",
    },
    {
      country: "ฟิลิปปินส์",
      production: "600",
      productionValue: "480",
      percentUtilize: "80%",
      inUsed: "402",
      percentInused: "83%",
      customer: "81",
      percentCustomer: "17%",
    },
    {
      country: "บังคลาเทศ",
      production: "480",
      productionValue: "425",
      percentUtilize: "88%",
      inUsed: "110",
      percentInused: "26%",
      customer: "315",
      percentCustomer: "74%",
    },
    {
      country: "โปแลนด์",
      production: "240",
      productionValue: "202",
      percentUtilize: "84%",
      inUsed: "202",
      percentInused: "100%",
      customer: "",
      percentCustomer: "",
    },
    {
      country: "ลาว",
      production: "210",
      productionValue: "187",
      percentUtilize: "89%",
      inUsed: "127",
      percentInused: "68%",
      customer: "60",
      percentCustomer: "32%",
    },
    {
      country: "ปากีสถาน",
      production: "96",
      productionValue: "86",
      percentUtilize: "89%",
      inUsed: "11",
      percentInused: "12%",
      customer: "75",
      percentCustomer: "88%",
    },
  ];

  // const data = React.useMemo(() => makeData(100), []);
  const [data, setData] = React.useState(makeData(100));

  // React.useEffect(() => {
  //   setData(makeData(100));
  // }, []);
  const handleReset = () => {
    setData(makeData(100));
  };

  return (
    <div className="cpf-world-wide-table-lib">
      <button onClick={handleReset}>Reset Data</button>
      <Table columns={columns} data={dataSet} />
    </div>
  );
}
